/**
 * Get visual information for a process stage
 * @param {string} stage - The process stage identifier
 * @returns {Object} Object with color, label, and short label for the stage
 */
export const getProcessStageInfo = (stage) => {
    let processStyle = { 
        color: 'rgba(189, 189, 189, 0.4)', 
        borderColor: 'rgb(189, 189, 189)',
        label: 'Processing', 
        shortLabel: '...' 
    };
    
    switch(stage) {
        case 'LEVEL0_AI_COMPLETE':
            processStyle =  { 
                color: 'rgba(140, 158, 255, 0.8)', 
                borderColor: 'rgb(140, 158, 255)',
                label: 'AI Generated', 
                shortLabel: 'AI' 
            };
            break;
        case 'LEVEL1_SEVAK_COMPLETE':
            processStyle =  { 
                color: 'rgba(100, 181, 246, 0.8)', 
                borderColor: 'rgb(100, 181, 246)',
                label: 'Level 1 Complete', 
                shortLabel: 'L1' 
            };
            break;
        case 'LEVEL2_SEVAK_COMPLETE':
            processStyle =  { 
                color: 'rgba(77, 182, 172, 0.8)', 
                borderColor: 'rgb(77, 182, 172)',
                label: 'Level 2 Complete', 
                shortLabel: 'L2' 
            };
            break;
        case 'LEVEL3_SEVAK_COMPLETE':
            processStyle =  { 
                color: 'rgba(129, 199, 132, 0.8)', 
                borderColor: 'rgb(129, 199, 132)',
                label: 'Level 3 Complete', 
                shortLabel: 'L3' 
            };
            break;
        case 'PUBLISHED':
            processStyle =  { 
                color: 'rgba(102, 187, 106, 0.8)', 
                borderColor: 'rgb(102, 187, 106)',
                label: 'Published', 
                shortLabel: 'P' 
            };
            break;
        default:
            processStyle =  { 
                color: 'rgba(189, 189, 189, 0.4)', 
                borderColor: 'rgb(189, 189, 189)',
                label: 'Processing', 
                shortLabel: '...' 
            };
            break;
    }
};

/**
 * Get the color for a language chip based on its process stage
 * @param {string} processStage - The process stage of the language
 * @returns {string} The color code for the chip's border
 */
export const getChipColor = (processStage) => {
    let color = '#9e9e9e'; // Default color for unknown/processing stagesq
    switch(processStage) {
        case 'PUBLISHED':
            color  = '#4caf50';
            break; // Green for published
        case 'LEVEL3_WIP':
        case 'LEVEL3_SEVAK_COMPLETE':
            color  =  '#9c27b0';
            break; // Purple for level 3 complete
        case 'LEVEL2_WIP':
        case 'LEVEL2_SEVAK_COMPLETE':
            color  =  '#673ab7';
            break; // Deep purple for level 2 complete
        case 'LEVEL1_WIP':
        case 'LEVEL1_SEVAK_COMPLETE':
            color  =  '#2196f3';
            break; // Blue for level 1 complete
        case 'LEVEL0_AI_COMPLETE':
            color  =  '#ff9800'; 
            break;// Orange for AI-generated
        default:
            color  =  '#9e9e9e';
            break; // Grey for unknown/processing
    }

    return color;
};

/**
 * Get user-friendly label for a process stage
 * @param {string} processStage - The process stage
 * @returns {string} A user-friendly label for the stage
 */
export const getProcessStageLabel = (processStage) => {
    switch(processStage) {
        case 'PUBLISHED':
            return 'Published';
        case 'LEVEL3_SEVAK_COMPLETE':
            return 'Level 3 Complete';
        case 'LEVEL2_SEVAK_COMPLETE':
            return 'Level 2 Complete';
        case 'LEVEL1_SEVAK_COMPLETE':
            return 'Level 1 Complete';
        case 'LEVEL0_AI_COMPLETE':
            return 'AI Complete';
        case 'LEVEL3_WIP':
            return 'Level 3 In Progress';
        case 'LEVEL2_WIP':
            return 'Level 2 In Progress';
        default:
            return 'Generating';
    }
};
/**
 * Get user-friendly label for a process stage
 * @param {string} processStage - The process stage
 * @returns {string} A user-friendly label for the stage
 */
export const getChipLabel = (language, processStage) => {
    switch(processStage) {
        case 'PUBLISHED':
            return language + ' - P';
        case 'LEVEL3_SEVAK_COMPLETE':
            return language + ' - L3';
        case 'LEVEL2_SEVAK_COMPLETE':
            return language + ' - L2';
        case 'LEVEL1_SEVAK_COMPLETE':
            return language + ' - L1';
        case 'LEVEL0_AI_COMPLETE':
            return language + ' - AI';
        case 'LEVEL3_WIP':
            return language + ' - L2';
        case 'LEVEL2_WIP':
            return language + ' - L1';
        default:
            return language + ' - G';;
    }
};

// Get color for process stage
export const getProcessStageColor = (stage) => {
    if (!stage) return '#757575';

    if (stage.includes('LEVEL0')) return '#ff9800';
    if (stage.includes('LEVEL1')) return '#2196f3';
    if (stage.includes('LEVEL2')) return '#9c27b0';
    if (stage.includes('LEVEL3')) return '#3f51b5';
    if (stage.includes('PUBLISHED')) return '#4caf50';

return '#757575';
};